import Mention from '@tiptap/extension-mention';
import tippy from 'tippy.js';

const loadTeammates = () => {
  const teammates = document.querySelector('meta[name=designer-teammates]');
  const data = JSON.parse(teammates.content);

  return data.map(({ name: label, ...rest }) => ({ label, ...rest }));
};

const prepareItems = (props, popup, component) => {
  component.innerHTML = '';
  props.items.forEach((item) => {
    const itemElement = document.createElement('div');
    itemElement.className = 'mention-item designer-teammate';
    itemElement.innerHTML = `
      <img src="${item.image_url}" class="designer-teammate__avatar">
      <div class="designer-teammate__name">${item.label}</div>
      <div class="designer-teammate__email">${item.email}</div>
    `;
    itemElement.addEventListener('click', () => {
      props.command(item);
      if (popup.state.isVisible) {
        popup.hide();
      }
    });
    component.appendChild(itemElement);
  });
};

const updateSelectedItem = (list, currentItem) => {
  const mentions = list.querySelectorAll('.mention-item');

  mentions.forEach((el) => el.classList.remove('selected'));
  mentions[currentItem]?.classList.add('selected');
};

const suggestion = {
  items: ({ editor, query }) => {
    if (!editor.storage._teammates) {
      editor.storage._teammates = loadTeammates();
    }

    const result = editor.storage._teammates
      .filter((item) => item.label.toLowerCase().includes(query.toLowerCase()))
      .slice(0, 5);

    return result;
  },

  render: () => {
    let popup;
    let suggestionProps;
    let currentItem;
    const list = document.createElement('div');
    list.className = 'mention-list';

    return {
      onStart: (props) => {
        currentItem = -1;
        suggestionProps = props;
        popup = tippy(document.body, {
          getReferenceClientRect: props.clientRect,
          appendTo: () => document.body,
          content: list,
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          placement: 'bottom-start',
          arrow: false,
          theme: 'mention',
          maxWidth: 'none',
        });
        prepareItems(props, popup, list);
      },

      onUpdate: (props) => {
        suggestionProps = props;
        popup.setProps({
          getReferenceClientRect: props.clientRect,
        });
        prepareItems(props, popup, list);
      },

      onKeyDown: (props) => {
        switch (props.event.key) {
          case 'ArrowDown':
            if (currentItem < suggestionProps.items.length - 1) {
              currentItem += 1;
              updateSelectedItem(list, currentItem);
            }
            return true;
          case 'ArrowUp':
            if (currentItem > 0) {
              currentItem -= 1;
              updateSelectedItem(list, currentItem);
            }
            return true;
          case 'Enter':
            const mentions = suggestionProps.items;
            const selectedItem = mentions[currentItem % mentions.length];
            if (selectedItem) {
              suggestionProps.command(selectedItem);
              currentItem = null;
            }
            return true;
        }

        return false;
      },

      onExit: () => {
        if (popup.state.isVisible) {
          popup.hide();
        }
        if (!popup.state.isDestroyed) {
          popup.destroy();
        }
      },
    };
  },
};

const mentionConfig = {
  suggestion,
};

export default [Mention.configure(mentionConfig)];
